import { type ReactNode, createContext, useContext } from 'react'

const TxSubmissionBlockedContext = createContext(false)

interface TxSubmissionGuardProps {
  blocked: boolean
  children: ReactNode
}

export const TxSubmissionGuard = ({ blocked, children }: TxSubmissionGuardProps) => {
  const parentBlocked = useTxSubmissionBlocked()
  const submissionBlocked = parentBlocked || blocked

  return (
    <TxSubmissionBlockedContext.Provider value={submissionBlocked}>
      <div
        className="contents"
        onSubmitCapture={(event) => {
          if (submissionBlocked) {
            event.preventDefault()
            event.stopPropagation()
          }
        }}
      >
        {children}
      </div>
    </TxSubmissionBlockedContext.Provider>
  )
}

export const useTxSubmissionBlocked = () => useContext(TxSubmissionBlockedContext)
